import { appContent } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-secondary-500 rounded-3xl p-6 md:p-10 lg:p-14 text-center text-white overflow-hidden relative">
          <div
            className="absolute inset-0 opacity-10 pointer-events-none"
            style={{
              backgroundImage:
                'radial-gradient(circle at 20% 50%, rgba(255,255,255,0.5) 0%, transparent 60%), radial-gradient(circle at 80% 30%, rgba(255,255,255,0.3) 0%, transparent 50%)',
            }}
          ></div>

          <div className="relative z-10">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white text-xs font-medium mb-5">
              <i className="ri-smartphone-line"></i>
              <span>移动端体验</span>
            </div>

            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold mb-4">
              {appContent.title}
            </h2>
            <p className="text-sm md:text-base text-white/80 max-w-xl mx-auto mb-8">
              {appContent.desc}
            </p>

            <div className="flex flex-wrap justify-center gap-3 mb-8">
              {appContent.features.map((feat) => (
                <span
                  key={feat}
                  className="text-xs md:text-sm px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm text-white whitespace-nowrap"
                >
                  <i className="ri-check-line mr-1.5"></i>
                  {feat}
                </span>
              ))}
            </div>

            <a
              href="#hero"
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white text-primary-600 font-semibold text-sm hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-lg"></i>
              立即开始观影
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}